/* ===============================================
  #URL parser
================================================== */
/*! js-url - v2.5.0 - 2017-04-22 */
!function(){var a=function(){function a(){}function b(a){return decodeURIComponent(a.replace(/\+/g," "))}function c(a,b){var c=a.charAt(0),d=b.split(c);return c===a?d:(a=parseInt(a.substring(1),10),d[a<0?d.length+a:a-1])}function d(a,c){for(var d=a.charAt(0),e=c.split("&"),f=[],g={},h=[],i=a.substring(1),j=0,k=e.length;j<k;j++)if(f=e[j].match(/(.*?)=(.*)/),f||(f=[e[j],e[j],""]),""!==f[1].replace(/\s/g,"")){if(f[2]=b(f[2]||""),i===f[1])return f[2];h=f[1].match(/(.*)\[([0-9]+)\]/),h?(g[h[1]]=g[h[1]]||[],g[h[1]][h[2]]=f[2]):g[f[1]]=f[2]}return d===a?g:g[i]}return function(b,e){var f,g={};if("tld?"===b)return a();if(e=e||window.location.toString(),!b)return e;if(b=b.toString(),f=e.match(/^mailto:([^\/].+)/))g.protocol="mailto",g.email=f[1];else{if((f=e.match(/(.*?)\/#\!(.*)/))&&(e=f[1]+f[2]),(f=e.match(/(.*?)#(.*)/))&&(g.hash=f[2],e=f[1]),g.hash&&b.match(/^#/))return d(b,g.hash);if((f=e.match(/(.*?)\?(.*)/))&&(g.query=f[2],e=f[1]),g.query&&b.match(/^\?/))return d(b,g.query);if((f=e.match(/(.*?)\:?\/\/(.*)/))&&(g.protocol=f[1].toLowerCase(),e=f[2]),(f=e.match(/(.*?)(\/.*)/))&&(g.path=f[2],e=f[1]),g.path=(g.path||"").replace(/^([^\/])/,"/$1"),b.match(/^[\-0-9]+$/)&&(b=b.replace(/^([^\/])/,"/$1")),b.match(/^\//))return c(b,g.path.substring(1));if(f=c("/-1",g.path.substring(1)),f&&(f=f.match(/(.*?)\.(.*)/))&&(g.file=f[0],g.filename=f[1],g.fileext=f[2]),(f=e.match(/(.*)\:([0-9]+)$/))&&(g.port=f[2],e=f[1]),(f=e.match(/(.*?)@(.*)/))&&(g.auth=f[1],e=f[2]),g.auth&&(f=g.auth.match(/(.*)\:(.*)/),g.user=f?f[1]:g.auth,g.pass=f?f[2]:void 0),g.hostname=e.toLowerCase(),"."===b.charAt(0))return c(b,g.hostname);a()&&(f=g.hostname.match(a()),f&&(g.tld=f[3],g.domain=f[2]?f[2]+"."+f[3]:void 0,g.sub=f[1]||void 0)),g.port=g.port||("https"===g.protocol?"443":"80"),g.protocol=g.protocol||("443"===g.port?"https":"http")}return b in g?g[b]:"{}"===b?g:void 0}}();"function"==typeof window.define&&window.define.amd?window.define("js-url",[],function(){return a}):("undefined"!=typeof window.jQuery&&window.jQuery.extend({url:function(a,b){return window.url(a,b)}}),window.url=a)}();

var filtersBarOffset = $(".main-collection-custom-filters").offset().top;
var filtersHeight = $(".main-collection-custom-filters").height();
var stickyHeaderH = $("sticky-header header.header").outerHeight();
const totalFiltersSelected = $(".q-total-filters-applied");
const resetFiltersLink = $(".reset-filters-link");

if(sessionStorage.getItem("colorWall")){

    if(url('?page') !== undefined){
        $("#CollectionProductGrid").addClass('color-wall');
        $(".color-wall-toggle input[type='checkbox']").prop("checked", true);
    }else{
        sessionStorage.removeItem("colorWall");
    }
}

Shopify.queryParams = {};
if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
    }
}

//When a option inside the Filter is selected
$('body').on('click', '.facets__wrapper input', function(){
    displayFilterButtons();
    displayQSelectedFilters();
});

//Reset Filters - Clear all the Filters and reset the grid
$("body").on("click", '[data-reset-filters]', function(event){
    event.preventDefault();
    event.stopPropagation();
    $('.facets__wrapper input:checked').each(function(){
        $(this).trigger('click');
    });
    $('.filter-text__title').text("Filter");
    setTimeout(function() {
        closeMobileFilters();
        $(".buttons-wrapper").removeClass('show');
        $('.controls-wrapper').find('.filter-text__title').text("Filter");
    }, 10);
});

$("body").on("click", '#apply-filters', function(event){
    event.preventDefault();
    closeMobileFilters();
});

$("body").on("change", "select[name='sort_by']:visible", function(){
    var url = new URL(window.location.href);
    var search_params = url.searchParams;
    search_params.set('sort_by', this.value);
    FacetFiltersForm.renderPage(search_params.toString());
});

$("body").on("change", ".color-wall-toggle input[type='checkbox']", function(){
    if($(this).is(":checked")){
        $("#CollectionProductGrid").addClass('color-wall');
        sessionStorage.setItem("colorWall", true);
    }else{
        $("#CollectionProductGrid").removeClass('color-wall').removeClass('wall-image-first');
        sessionStorage.removeItem("colorWall");
    }
});

$(document).ready(function() {
    const colorWallToggle = $(".color-wall-toggle input[type='checkbox']");
    if($(colorWallToggle).is(":checked")){
        $("#CollectionProductGrid").addClass('color-wall');
        sessionStorage.setItem("colorWall", true);
    }else{
        $("#CollectionProductGrid").removeClass('color-wall');
        sessionStorage.removeItem("colorWall");
    }
});

$(document).ready(function() {
    const colorWallToggle = $(".color-wall-toggle input[type='checkbox']");
    if($(colorWallToggle).is(":checked")){
        $("#CollectionProductGrid").addClass('color-wall');
        sessionStorage.setItem("colorWall", true);
    }else{
        $("#CollectionProductGrid").removeClass('color-wall');
        sessionStorage.removeItem("colorWall");
    }
});

$(document).ready(function() {
    const colorWallToggle = $(".color-wall-toggle input[type='checkbox']");
    if($(colorWallToggle).is(":checked")){
        $("#CollectionProductGrid").addClass('color-wall');
        sessionStorage.setItem("colorWall", true);
    }else{
        $("#CollectionProductGrid").removeClass('color-wall');
        sessionStorage.removeItem("colorWall");
    }
});

//Show / Open the Filters
$("body").on("click", ".controls-wrapper", function(){
    if (window.matchMedia( "(min-width: 835px)" ).matches) {
        $(this).closest('.main-collection-custom-filters').toggleClass('show');
        if ($(this).closest('.main-collection-custom-filters').hasClass('show')) {
            $(this).find('.filter-text__title').text("Close Filter");
        } else {
            $(this).find('.filter-text__title').text("Filter");
        }
    }
});

$(window).resize(function() {
    if (window.matchMedia( "(max-width: 834px)" ).matches) {
        $('.main-collection-custom-filters').find('.filter-text__title').text("Filter");
    }
});

$("body").on("click", ".toggle-filters", function(){
    if (window.matchMedia( "(min-width: 835px)" ).matches) {
        return;
    } else {
        $(this).closest('.main-collection-custom-filters').addClass('show');
        displayFilterButtons();
        $("body").addClass('no-scroll');
    }
});

//Hide the Filters
$("body").on("click", ".close-menu-mobile", function(event){
    event.preventDefault();
    closeMobileFilters();
});

// Shortcircuit variable
var triggered = false;

function loadMoreProducts() {
    if($('#more').length) {

        $('#more').on('click', function(e){
            e.preventDefault();
        })

        // Locate loadmore button
        const moreButon = $('#more').last();
        // Get URL from the loadmore button
        const nextUrl = $(moreButon).find('a').attr("href");

        // Button position when AJAX call should be made one time
        if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (triggered == false)) {
            // Trigger shortcircuit to ensure AJAX only fires once
            triggered = true;
            // Make ajax call to next page for load more data
            $.ajax({
                url: nextUrl,
                type: 'GET',
                beforeSend: function () {

                }
            })
            .done(function (data) {
                moreButon.remove();
                // Append data
                $('#main-collection-product-grid').append($(data).find('ul.product-grid').html());
                // On success, reset shortcircuit
                triggered = false;

                if(window._swat){
                    window._swat.initializeActionButtons(".product-grid");
                }else{
                    window.SwymCallbacks = window.SwymCallbacks || [];

                    window.SwymCallbacks.push(function(){
                        window._swat.initializeActionButtons(".product-grid");
                    });
                }
            });
        }
    }
}

$(window).scroll(function(){
    loadMoreProducts();
});

const purePolishProductType = 'pure-polish';

function closeMobileFilters(){
    $("body").removeClass('no-scroll');
    $('.main-collection-custom-filters').removeClass('show');
}
function displayQSelectedFilters(){
    if($('.facets__wrapper input:checked').length > 0){
        totalFiltersSelected.html("("+$('.facets__wrapper input:checked').length+")");
        resetFiltersLink.addClass('reset-filters-link--show');
    }else{
        totalFiltersSelected.html("");
        resetFiltersLink.removeClass('reset-filters-link--show');
    }
}
function displayFilterButtons(){
    if($('.facets__wrapper input:checked').length > 0){
        $(".buttons-wrapper").addClass('show');
    }else{
        $(".buttons-wrapper").removeClass('show');
    }
}
function enableColorWallToggleControl(){
    $(".color-wall-toggle-wrapper").addClass('enabled');
}
function disableFiltersForCollection(){
    $(".main-collection-custom-filters").addClass("filters-disabled");
    $("body").off("click", ".controls-wrapper")
}

//If the collection only contains Nail Polish products
if($(".card-wrapper[data-product-type=" + purePolishProductType + "]").length > 1 && $(".card-wrapper[data-product-type!=" + purePolishProductType + "]").length == 0){
    enableColorWallToggleControl();
} else {
    $(".color-wall-toggle-wrapper").remove();
}

//If the collection contains any other product type different of Nail Polish
if($(".card-wrapper[data-product-type!=" + purePolishProductType + "]").length > 0){
    disableFiltersForCollection();
}

displayQSelectedFilters();
